import React from "react";
import {Typography} from "antd";
import {
    AllPoolsCard as StyledAllPoolsCard,
    PoolCardContent,
    AllPoolsTitle,
    AllPoolsText
} from "./PoolsListModal.styles";

const AllPoolsCard = ({totalPools, isSelected, onSelect}) => (
    <StyledAllPoolsCard selected={isSelected} onClick={onSelect}>
        <PoolCardContent align="center" style={{width: "100%", justifyContent: "space-between"}}>
            <div>
                <AllPoolsTitle level={5}>Tümünü Göster</AllPoolsTitle>
                <AllPoolsText type="secondary">Toplam Havuz: {totalPools}</AllPoolsText>
            </div>
        </PoolCardContent>
    </StyledAllPoolsCard>
);

export default AllPoolsCard; 